<template>
  <div>
    <el-dialog
      v-loading="loading"
      title="Create Lesson"
      :visible.sync="dialogCreateVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-form ref="postForm" :model="postForm" :rules="rules" label-width="140px" class="demo-ruleForm">
        <div class="createPost-main-container">
          <el-row>
            <el-col :span="24">
              <el-form-item label="老師:" style="margin-bottom: 30px;" prop="teacher">
                <multiselect v-model="postForm.teacher" :options="teacherOptions" :custom-label="nameWithLang" placeholder="Select..." label="name" track-by="name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="課程名稱:" style="margin-bottom: 30px;" prop="course">
                <multiselect v-model="postForm.course" :options="courseOptions" :custom-label="nameWithLang" placeholder="Select..." label="name" track-by="name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="學生:" style="margin-bottom: 30px;" prop="students">
                <multiselect v-if="postForm.type==='tutor'" v-model="postForm.students" :options="studentOptions" :custom-label="nameWithLang" placeholder="Select..." label="name" track-by="name" />
                <multiselect v-if="postForm.type==='group'" v-model="postForm.students" :options="studentOptions" :close-on-select="false" :custom-label="nameWithLang" placeholder="Select..." :multiple="true" :max="postForm.groupMaxEnrollNum" label="name" track-by="name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="課程類型:" style="margin-bottom: 30px;" prop="typeName">
                <span>{{ postForm.typeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="課堂定價:" style="margin-bottom: 30px;" prop="price">
                <span>{{ postForm.price }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="postForm && postForm.course && postForm.course.type == 'group'">
              <el-form-item label="團體課最大人數:" style="margin-bottom: 30px;" prop="groupMaxEnrollNum">
                <span>{{ postForm.groupMaxEnrollNum }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="Time Zone:">
                <span>{{ timezone }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <ul label="上課時間:">
                <li v-for="(input, index) in postForm.timeDatas" :key="index" style="list-style-type:none;">
                  <el-col :span="18">
                    <el-form-item :label="`${ index + 1 } 日期時間 :`" style="margin-bottom: 30px;" prop="date">
                      <el-date-picker
                        v-model="input[0]"
                        style="width:74%;"
                        type="datetimerange"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="開始日期時間-結束日期時間"
                        value-format="yyyy-MM-dd HH:mm"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-button v-show="index!=0" type="danger" @click="deleteTimeRow(index)">刪除</el-button>
                  </el-col>
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <el-button type="primary" @click="addTimeRow()">新增課堂日期時間</el-button>
                <el-button type="danger" @click="onCreateEvent($event)">Create</el-button>
                <el-button @click="handleClose()">Cancel</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import EventResource from '@/api/event'

const eventResource = new EventResource()

const defaultForm = {
  type: 'tutor',
  typeName: '家教課',
  price: 0,
  timeDatas: [[]],
  groupMaxEnrollNum: 0,
  teacher: [],
  students: [],
  course: []
}
export default {
  name: 'CreateDialog',
  components: { Multiselect },
  props: {
    dialogCreateVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    const validateTeacher = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('請選擇老師'))
      } else {
        callback()
      }
    }
    const validateCourse = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('請選擇課程'))
      } else {
        callback()
      }
    }
    const validateStudents = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('請至少選擇一個學生'))
      } else {
        callback()
      }
    }
    return {
      postForm: Object.assign({}, defaultForm),
      loading: false,
      rules: {
        teacher: [{ validator: validateTeacher, trigger: 'blur' }],
        course: [{ validator: validateCourse, trigger: 'blur' }],
        students: [{ validator: validateStudents, trigger: 'blur' }]
      },
      teacherOptions: [],
      studentOptions: [],
      courseOptions: [],
      timeOptions: []
    }
  },
  computed: {
    ...mapGetters([
      'timezone'
    ])
  },
  watch: {
    'postForm.course': function() {
      if (this.postForm.course) {
        this.postForm.type = this.postForm.course.type
        this.postForm.price = this.postForm.course.price
        this.postForm.students = undefined
        if (this.postForm.course.type === 'tutor') {
          this.postForm.typeName = '家教課'
        } else {
          this.postForm.typeName = '團體課'
        }
        this.postForm.groupMaxEnrollNum = this.postForm.course.groupMaxEnrollNum
      }
    }
  },
  methods: {
    async open() {
      this.loading = true
      this.data = this.$parent.currentEditItem
      await this.getLessonInputOptions()
      this.loading = false
    },
    addTimeRow() {
      this.postForm.timeDatas.push([null])
    },
    deleteTimeRow(index) {
      this.postForm.timeDatas.splice(index, 1)
    },
    async getLessonInputOptions() {
      const { teacher, course, student } = await eventResource.getLessonInputOptions()
      console.log(teacher)
      const teacherOptions = []
      teacher.forEach(function(item) {
        teacherOptions.push({ number: item.number, name: item.name })
      })
      this.teacherOptions = teacherOptions

      const courseOptions = []
      course.forEach(function(item) {
        courseOptions.push({ number: item.number, name: item.title, type: item.type, price: item.price, groupMaxEnrollNum: item.group_max_enroll_num })
      })
      this.courseOptions = courseOptions

      const studentOptions = []
      student.forEach(function(item) {
        studentOptions.push({ number: item.number, name: item.name })
      })
      this.studentOptions = studentOptions
    },
    onCreateEvent(event) {
      this.$refs.postForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.sendData()
      })
    },
    async sendData() {
      console.log(this.postForm)
      const { data } = await eventResource.createLesson(this.postForm)
      const actionTitle = 'Create Lesson '
      if (data.code === 0) {
        this.$parent.dialogCreateVisible = false
        this.reloadParentData()
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
      } else {
        this.$parent.messageNotify(
          actionTitle,
          data.errors,
          'error'
        )
        return false
      }
    },
    handleClose(done) {
      this.$confirm('Are you sure to close this window?', 'Tip', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(() => {
        this.resetData()
        this.$parent.dialogCreateVisible = false
      }).catch(() => {
        return false
      })
    },
    reloadParentData() {
      this.$parent.getList()
      this.resetData()
    },
    resetData() {
      this.$refs.postForm.resetFields()
      this.postForm = {
        type: 'tutor',
        typeName: '家教課',
        price: 0,
        timeDatas: [[]],
        groupMaxEnrollNum: 0,
        teacher: [],
        students: [],
        course: []
      }
    },
    nameWithLang({ name, number }) {
      return `${name} — [${number}]`
    },
    idWithLang({ name, id }) {
      return `${name}`
    }
  }
}
</script>
